export default {
  string: function (size, required = true) {
    let rule = { required: required, pattern: new RegExp(`^.{1,${size}}$`), message: `长度在${size}字以内`, trigger: 'blur' }
    return rule
  },
  string2: function (size, required = true) {
    let rule = { required: required, pattern: new RegExp(`^.{1,${size}}$`), message: `请输入`, trigger: 'blur' }
    return rule
  },
  password: function (min, max, required = true) {
    let rule = { required: required, pattern: new RegExp(`^.{${min},${max}}$`), message: `请输入合法的${min}到${max}位密码`, trigger: 'blur' }
    return rule
  },
  passWord: function (required = true) {
    let rule = { required: required, pattern: new RegExp(`^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$`), message: `请输入6-12位数字与字母组合密码`, trigger: 'blur' }
    return rule
  },
  vcode: function (size, required = true) {
    let rule = { required: required, pattern: new RegExp(`^\\d{${size}}$`), message: `请输入${size}位验证码`, trigger: 'blur' }
    return rule
  },
  textarea: function (size, required = true) {
    let rule = { required: required, pattern: new RegExp(`^[\\s\\S]{1,${size}}$`), message: `长度在${size}字以内`, trigger: 'blur' }
    return rule
  },
  fileName: function (size, required = true) {
    let rule = { required: required, pattern: new RegExp(`^[^\\\\/:*?<>|\\s"]{1,${size}}$`), message: `不能包含特殊符号且长度在${size}字以内`, trigger: 'blur' }
    return rule
  },
  fileName2: function (size, required = true) {
    let rule = { required: required, pattern: new RegExp(`^[^\\\\/:*?<>|#&！!～【】《》%$+={}\\s"]{1,${size}}$`), message: `不能包含特殊符号且长度在${size}字以内`, trigger: 'blur' }
    return rule
  },
  ipAddress: function (required = true) {
    let rule = { required: required, pattern: new RegExp(`^\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}$`), message: `不是合法的IP地址`, trigger: 'blur' }
    return rule
  },
  mobile: function (required = true) {
    let rule = { required: required, pattern: new RegExp(`^1\\d{10}$`), message: `不是合法的手机号码`, trigger: 'blur' }
    return rule
  },
  idCard: function (required = true) {
    let rule = { required: required, pattern: new RegExp(`^\\d{15}(\\d{2}[0-9xX])?$`), message: `不是合法的身份证号码`, trigger: 'blur' }
    return rule
  },
  email: function (required = true) {
    let rule = { required: required, pattern: new RegExp(`^([a-z0-9_\\\\.-]+)@([\\da-z\\\\.-]+)\\.([a-z\\\\.]{2,6})$`), message: `不是合法的邮箱地址`, trigger: 'blur' }
    return rule
  },
  telephone: function (required = true) {
    let rule = { required: required, pattern: new RegExp(`^[0][\\d]{10}$`), message: `不是合法的座机号码`, trigger: 'blur' }
    return rule
  },
  chinese (size, required = true) {
    let rule = { required: required, pattern: new RegExp(`^[\u4E00-\u9FA5\u0020]{1,${size}}$`), message: `由中文组成且长度在${size}字以内`, trigger: 'blur' }
    return rule
  },
  integer (isBig0 = true, required = true) {
    if (isBig0) {
      let rule = { required: required, pattern: new RegExp(`^[1-9]\\d*$`), message: `必须是大于0的整数`, trigger: 'blur' }
      return rule
    } else {
      let rule = { required: required, pattern: new RegExp(`^\\d*$`), message: `必须是整数`, trigger: 'blur' }
      return rule
    }
  },
  number (isBig0 = true, required = true) {
    if (isBig0) {
      let rule = { required: required, pattern: new RegExp(`^[\\d\\\\.]*[1-9][\\d\\\\.]*$`), message: `必须是大于0的数字`, trigger: 'blur' }
      return rule
    } else {
      let rule = { required: required, pattern: new RegExp(`^[\\d\\\\.]+$`), message: `不是合法的数字`, trigger: 'blur' }
      return rule
    }
  }
}
